import { usePublishedPrices } from '../../features/catalog/queries';
import { quotePrice, type PriceSpec } from '../../lib/contentPrice';

/**
 * AnyAPI's published price for a SKU, written into a post as
 * `<Price sku="google.search" />` instead of a typed number, so the prerendered
 * article states what the catalog charged when the site was built. The forms
 * are `PriceSpec`'s; content/CLAUDE.md is where post authors read them.
 *
 * The dash is for a render with no catalog at all: a live navigation that
 * could not reach it, or the content sandbox build, which has none. The shipped
 * build has the catalog or fails, and an unknown SKU throws.
 */
export const Price = (spec: PriceSpec) => {
  const prices = usePublishedPrices();
  return <>{prices ? quotePrice(prices, spec).text : '-'}</>;
};
